module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "oneStudentReport"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "btn",
    on: {
      "click": _vm.goBack
    }
  }, [_c('i', {
    staticClass: "icon_back"
  }), _vm._v(" 返回")]), _vm._v("\n    学生作业报告详情\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "oneBox"
  }, [(_vm.leftBar) ? _c('div', {
    staticClass: "oneBoxL"
  }, [_c('ul', _vm._l((_vm.studentAllList), function(item, index) {
    return _c('li', {
      class: {
        active: index == (_vm.ranking - 1)
      },
      on: {
        "click": function($event) {
          _vm.toggleStudent(item)
        }
      }
    }, [_c('span', {
      staticClass: "fl"
    }, [_vm._v(_vm._s(item.userName))]), _vm._v(" "), _c('span', {
      staticClass: "fr smallF"
    }, [_vm._v(_vm._s(item.totalScore))])])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "oneBoxR",
    class: {
      oneRwidth: !_vm.leftBar
    }
  }, [_c('span', {
    staticClass: "leftBtn",
    on: {
      "click": _vm.hideLeftBar
    }
  }, [_c('i', {
    staticClass: "iconBtn iconBtnLeft",
    class: {
      iconBtnRight: !_vm.leftBar
    }
  })]), _vm._v(" "), _c('nav', {
    staticClass: "oneNav"
  }, [_c('span', {
    staticClass: "oneName"
  }, [_vm._v(_vm._s(_vm.userName))]), _vm._v(" "), _c('span', {
    staticClass: "wtUp",
    on: {
      "click": _vm.lastStudent
    }
  }, [_c('i'), _vm._v(" "), _c('span', [_vm._v("上一个")])]), _vm._v(" "), _c('span', {
    staticClass: "wtNext",
    on: {
      "click": _vm.nextStudent
    }
  }, [_c('i'), _vm._v(" "), _c('span', [_vm._v("下一个")])])]), _vm._v(" "), _c('div', {
    staticClass: "dataBox"
  }, [_c('div', {
    staticClass: "basicInfo"
  }, [_c('span', {
    staticClass: "tip"
  }, [_vm._v("基本情况")]), _vm._v(" "), _c('table', [_c('tr', [_c('th', [_vm._v("成绩排名")]), _vm._v(" "), _c('th', [_vm._v("\n              得分\n              "), _c('el-popover', {
    attrs: {
      "placement": "bottom",
      "width": "200",
      "trigger": "hover",
      "content": "一段时间内，学生平均得分，换算成百分制。"
    }
  }, [_c('i', {
    staticClass: "iconQMark",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  })])], 1), _vm._v(" "), _c('th', [_vm._v("班级平均分\n              "), _c('el-popover', {
    attrs: {
      "placement": "bottom",
      "width": "200",
      "trigger": "hover",
      "content": "一段时间内，学生平均得分，换算成百分制。"
    }
  }, [_c('i', {
    staticClass: "iconQMark",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  })])], 1), _vm._v(" "), _c('th', [_vm._v("提交率")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.workReport.ranking))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.workReport.avgScore))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.workReport.classAvgRelativeScore))]), _vm._v(" "), _c('td', {
    staticClass: "equalAvg",
    class: {
      'overAvg': _vm.workReport.submitRate > _vm.workReport.classSubmitRate, 'lowAvg': _vm.workReport.submitRate < _vm.workReport.classSubmitRate
    }
  }, [_vm._v(_vm._s(_vm.workReport.submitRate) + "%")])])])]), _vm._v(" "), _c('echartLine', {
    attrs: {
      "echartData": _vm.echartLineData,
      "userName": _vm.userName
    },
    on: {
      "setresourceType": _vm.setresourceType
    }
  }), _vm._v(" "), _c('echartPie', {
    attrs: {
      "echartData": _vm.echartPieData
    }
  }), _vm._v(" "), _c('workInfo', {
    attrs: {
      "reportDetail": _vm.reportDetail,
      "workReport": _vm.workReport,
      "timeData": _vm.timeData
    },
    on: {
      "setPage": _vm.setPage
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0236d7f0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/oneStudentReport.vue
// module id = 1152
// module chunks = 1